import React, { useContext } from 'react';
import classes from './HeaderMenuToggle.module.css';
import menuIcon from '../../../../Images/header-menu-toggle-icon.svg';
import { ChatbotContext } from '../../../../Contexts/ChatbotContext';
import useWebChat from "../../../../Hooks/useWebChat";
import { useLanguage } from '../../../Wizard/langugeContext';

function HeaderMenuToggle({ onClick }) {
  const { isMenuOpen, setIsMenuOpen } = useContext(ChatbotContext);
  const { sendLoggingEventToBackend } = useWebChat();
  const { currentLanguage } = useLanguage();

  const onMenuToggleClick = () => {
    setIsMenuOpen(prevState => {
      const newState = !prevState;
  
      // Send backend logging based on menu state
       let loggingState = newState ? "menuOpen" : "menuClosed";

       console.log("Logging event: ", loggingState);

        sendLoggingEventToBackend({
            intentName:  currentLanguage === "en" ? loggingState : loggingState+"Spanish",
            text: currentLanguage === "en" ? loggingState : loggingState+"Spanish"
        });
  
      // Call optional onClick function if provided
      if (onClick) {
        onClick(newState);
      }
  
      return newState;
    });
  };

  const handleKeyDown = (event) => {
   // console.log('Menu toggle keydown:', event.key);
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); 
     // console.log("Opening menu with Enter/Space");
      onMenuToggleClick(); 
    }
  };

  const handleFocus = () => {
   // console.log("Button is focused");
  };
  

  return (
    <button
      onClick={onMenuToggleClick}
      onKeyDown={handleKeyDown} 
      aria-expanded={isMenuOpen}
      aria-label="Toggle menu"
      className={classes['header-menu-toggle']}
      tabIndex="0" 
      onFocus={handleFocus} 
    >
      <img src={menuIcon} alt="Menu" />
    </button>
  );
}

export default HeaderMenuToggle;
